if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        var loadingbar = document.querySelector(".loading-bar");
        var loadingbarinner = document.querySelector(".loading-bar-inner");
        loadingbar.classList.add("is-visible");
        loadingbarinner.style.transform="scaleX(0.4)";
        var cursoreffect = document.querySelector("body");
        cursoreffect.classList.add("cursor-effect");          
          
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            
            loadingbarinner.style.transform="scaleX(1)";
            
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            console.log(responseHTML.querySelector('.product-tab-section'));
            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, (productElement.outerHTML.replaceAll("aiod-volume-discount-wrap custom","aiod-volume-discount-wrap")+ responseHTML.querySelector('.product-tab-section').outerHTML));

            setTimeout(function(){
              if($('.quick-add-modal').find('.carousel-main').length > 0) {
                $('.quick-add-modal').find('.carousel-main').flickity({
                   "contain": true,
                   "pageDots": false,
                   "sync": ".quick-add-modal .carousel-nav"
                });
              }
              if( $('.quick-add-modal').find('.carousel-nav').length > 0) {
                 $('.quick-add-modal').find('.carousel-nav').flickity({
                  "asNavFor": ".quick-add-modal .carousel-main",
                  "prevNextButtons": false,
                  "draggable": false,
                  "percentPosition": false,
                  "pageDots": false,
                  "groupCells": "100%",
                  "contain": true,
                  "cellAlign": 'left'
                });
              } 
            },450);
            setTimeout(function(){
              if($('.quick-add-modal').find('.carousel-main').length > 0) {
                $('.quick-add-modal').find('.carousel-main').flickity('resize');
              }
              if($('.quick-add-modal').find('.carousel-nav').length > 0) {
                $('.quick-add-modal').find('.carousel-nav').flickity('resize');
              }
            },500);
            
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            // if(window.myapp != undefined){
            // if (window.ProductModel) window.ProductModel.loadShopifyXR();
            // window.csapps.product = window.myapp.product_for_qv;
            // window.csapps.product_id = window.myapp.product_id_for_qv;
            // window.csapps.product_collections = window.myapp.product_collection_for_qv;
            // window.csapps.product.selected_variant = window.csapps.product.variants[0].id;
            // var e = window.csapps.vd_url + "/api/display-discount-table";
            // a = window.csapps.customer ? {
            //     product_id: window.csapps.product_id,
            //     shop: window.csapps.store_id,
            //     cid: window.csapps.customer.id,
            //     cemail: window.csapps.customer.email,
            //     collection_ids: window.csapps.product_collections,
            //     request_type: "1",
            //     currency: window.csapps.currency_code,
            //     country: window.csapps.country_code
            // } : {
            //     product_id: window.csapps.product_id,
            //     shop: window.csapps.store_id,
            //     collection_ids: window.csapps.product_collections,
            //     request_type: "1",
            //     currency: window.csapps.currency_code,
            //     country: window.csapps.country_code
            // };
            // var t = csapps.create_api_url(e, a);
            // console.log(t);   
            // if(void 0 == window.csapps.all_aiod_api[t]){
            //   window.csapps.volumn_request_ajax = $.ajax({
            //       type: "GET",
            //       url: e,
            //       timeout: 4e3,
            //       data: a,
            //       crossDomain: !0,
            //       dataType: "json",
            //       beforeSend: function() {
            //           "ToCancelPrevReq" != window.csapps.volumn_request_ajax && window.csapps.volumn_request_ajax.readyState < 4 && window.csapps.volumn_request_ajax.abort()
            //           window.csapps.page_type = "product";
            //       },
            //       success: function(s) {
            //           window.csapps.all_aiod_api[t] = s, set_aiod_api_json(t, s), s.data.length > 0 && (csapp_style(window.csapps.settings), "product" == window.csapps.page_type && table_post(s))
            //       },
            //       error: function(s, e) {
            //           csapp_checkout_enable(1, !1)
            //       }
            //   });
            // }else if ("product" == window.csapps.page_type) {
            //   var a = window.csapps.all_aiod_api[t];
            //   table_post(a);
            // }
            // }
            // function fire_variant_wise_call_aiod(){
            //   // if($('body .aiod-volume-discount-wrap .offer-wrpper').length > 0 && window.csapps.volumn_is_variant == 1){
            //     for(var i = 0; i < window.csapps.product.variants.length; i++){
            //       // console.log(window.csapps.product.variants[i]);
            //       window.csapps.product.selected_variant = window.csapps.product.variants[i].id;
            //       window.volumeTable();
            //       variant_based_tables[window.csapps.product.variants[i].id] = $('.aiod-volume-discount-wrap').html();
            //       // console.log(variant_based_tables);
            //     }
            //     for(var i = 0; i < window.csapps.product.variants.length; i++){
            //       $('.aiod-volume-discount-wrap[data-variant_id="'+ window.csapps.product.variants[i].id +'"]').html(variant_based_tables[window.csapps.product.variants[i].id]);
            //     }
            //   // }else{
            //   //   setTimeout(function(){
            //   //     fire_variant_wise_call_aiod();
            //   //   },300);
            //   // }
            // }
            // fire_variant_wise_call_aiod();
            
            super.show(opener);
            loadingbar.classList.remove("is-visible");
            loadingbarinner.style.transform="scaleX(0)";  
            
          })
          .finally(() => {

            loadingbar.classList.remove("is-visible");
            loadingbarinner.style.transform="scaleX(0)";
            cursoreffect.classList.remove("cursor-effect");     
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      preprocessHTML(productElement) {
        productElement.classList.forEach((classApplied) => {
          if (classApplied.startsWith('color-') || classApplied === 'gradient')
            this.modalContent.classList.add(classApplied);
        });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

// window.table_post_custom = function (e) {
//     if (e.data.length || window.csapps.settings.length) {
//      var s = e.data,
//         a = window.csapps.settings,
//         o = "";
//      $(s).each(function (e, s) {
//         var i = "";
//         "Variant" == s.offer_type_text && "Custom Selection" == s.selection_type_text ? (window.csapps.volumn_is_variant = 1, $(s.products).each(function (e, s) {
//            if (window.csapps.product_id == s.product_id) return i = s.default_variant_ids, !1
//         }), i.indexOf(window.csapps.product.selected_variant) > -1 && (window.csapps.Data_volume[s.id] ? o += window.csapps.Data_volume[s.id] : o += eligible_offer_custom(s, a))) : window.csapps.Data_volume[s.id] ? o += window.csapps.Data_volume[s.id] : o += eligible_offer_custom(s, a)
//      });
//      var i = a["table-design"].setting;
//      o += "<style>.csapps-volume-discount-tiers { border: " + i.table_border_width + "px  " + i.table_border_type + " " + i.table_border_color + ";  max-width: " + i.table_max_width + "; min-width: " + i.table_min_width + ";}.csapps-table thead {background-color: " + i.table_header_background_color + ";font-size: " + i.table_font_size + "px;color: #000000;}.csapps-table tbody {background-color:  " + i.table_background_color + ";font-size:  " + i.table_font_size + "px;color: " + i.table_font_color + "}.csapps-table th{font-style: " + i.table_header_font_style + ";border:0;padding:12px 15px;}.csapps-table thead tr th{border-bottom: " + i.table_border_width + "px " + i.table_border_type + " " + i.table_header_border_color + ";}.csapps-table tbody tr td{border-bottom: " + i.table_border_width + "px " + i.table_border_type + " " + i.table_border_color + ";}.csapps-table tbody tr:hover { background-color: " + i.table_hover_background_color + "; }</style>", $(".aiod-volume-discount-wrap").html(o)
//   }
// }

// window.eligible_offer_custom = function (e, s) {
//   var a, t, o = e,
//      i = o.discount_quantities,
//      p = o.display_offer_view_type_code,
//      c = void 0 !== o.min_amount && null != o.min_amount ? o.min_amount : 0;
//   return "2" == o.setting_type && (t = o.setting_json), console.log(o), a = get_offer_table_layout_custom(p, i, s, e.priority, e.id, c, t), window.csapps.Data_volume[e.id] = a, a
// }

// window.get_offer_table_layout_custom = function (e, s, a, o, i, p, c) {
//     var l, r, d, u, g = null != c && "" !== c ? c : a.language.setting.volume_settings,
//        f = (a["table-design"].setting, ""),
//        _ = null != g.minimum_quantity ? g.minimum_quantity : "",
//        m = null != g.maximum_quantity ? g.maximum_quantity : "",
//        $ = null != g.discount ? g.discount : "",
//        v = null != g.maximum_quantity_after ? g.maximum_quantity_after : "",
//        b = null != g.minimum_quantity_before ? g.minimum_quantity_before : "",
//        h = null != g.offer_text ? g.offer_text : "",
//        y = null != g.get_a_text ? g.get_a_text : "",
//        w = null != g.buy_more_save_more ? g.buy_more_save_more : "",
//        x = void 0 !== g.required_purchased_amount_msg && null != g.required_purchased_amount_msg ? g.required_purchased_amount_msg : "";
//     return "Detail Grid" == e || "Basic" == e || "Grid Range Alternate" == e ? ("" != w && (f += "<div class='offer-wrpper' data-priority='" + o + "' data-offer_id='" + i + "'><h4 class='heading_table'>" + w + "</h4>"), f += "<div class='csapps-volume-discount-tiers'><table class='csapps-table table'>", "" == _ && "" == $ || (f += "<thead><tr><th>" + _ + "</th><th>" + $ + "</th></tr></thead>"), f += "<tbody>") : ("" != w && (f += "<h4 class='heading_table'>" + w + "</h4>"), f += "<div class='csapps-volume-discount-tiers'><table class='csapps-table table'>", "" == _ && "" == m && "" == $ || (f += "<thead><tr><th>" + _ + "</th><th>" + m + "</th><th>" + $ + "</th></tr></thead>"), f += "<tbody>"), t.each(s, function (a, t) {
//        if (l = t.discount_type, d = t.discount_value, u = t.quantity, r = 2 == l ? "<span class='money'>" + csapps.formatMoney(100 * d, n) + "</span> " + h : 1 == l ? y + " <span class='money'>" + csapps.formatMoney(100 * d, n) + "</span>" : d + "% " + h, "Detail Grid" == e) f += "<tr><td>" + b + " " + u + " " + v + "</td><td>" + r + "</td></tr>";
//        else if ("Basic" == e) f += "<tr><td>" + u + " " + v + " </td><td><span class='csapps-price'>" + r + "</span></td></tr>";
//        else if ("Grid Range" == e) {
//           var o = u ? s[a + 1] ? s[a + 1].quantity - 1 : v : "";
//           f += "<tr><td>" + u + "</td><td>" + o + "</td><td><span class='csapps-price'>" + r + "</span></td></tr>"
//        } else "Grid Range Alternate" == e && (t == s[a - 1] ? f += "<tr><td>" + u + " + </td><td><span class='csapps-price'>" + r + "</span></td></tr>" : (o = u ? s[a + 1] ? s[a + 1].quantity - 1 : v : "", f += "<tr><td>" + u + "-" + o + "</td><td><span class='csapps-price'>" + r + "</span></td></tr>"))
//     }), f += "</tbody></table></div>" + (x = "" != x && (p > 1 || p >= 1 && "Spend {{amount}} to get offer." != x) ? x.indexOf("{{amount}}") > -1 ? "<p class='volume_required_msg'>" + x.replace("{{amount}}", "<span class='money'>" + csapps.formatMoney(100 * p, n) + "</span>") + "</p>" : "<p class='volume_required_msg'>" + x + "</p>" : "") + "</div>"
//  }